import { ChipProps, Chip as MuiChip } from "@mui/material";
import { cn } from "src/utils/ui";

export const Chip = ({
  className,
  label,
  size = "tiny",
  ...props
}: ChipProps) => {
  return (
    <MuiChip
      label={label}
      className={cn(
        "bg-purple-100 text-purple-500 border-purple-500 border-solid border",
        className
      )}
      size={size}
      {...props}
    />
  );
};
